import { Subtitle } from "chq";

const updateSubtitleSectionTimeById = (
  creatomateId: string,
  time: number,
  duration: number,
  subtitles: Subtitle[],
  onUpdateSubtitles: (newData: Record<string, any>) => void
): void => {
  const activeSubtitleIndex = subtitles.findIndex(subtitle => subtitle.active);
  if (activeSubtitleIndex === -1) return;

  const sections = subtitles[activeSubtitleIndex]?.sections || [];
  const sectionIndex = sections.findIndex(subtitle => subtitle.creatomateId === creatomateId);
  if (sectionIndex === -1) return;

  const updatedSubtitles = subtitles.map(subtitle => ({
    ...subtitle,
    sections: subtitle.sections?.map((section, index) => {
      if (index !== sectionIndex) return section;
      return { ...section, startTime: time, endTime: time + duration };
    })
  }));

  onUpdateSubtitles({ debouncedSubtitlesHandler: true, subtitles: updatedSubtitles });
};

export default updateSubtitleSectionTimeById;
